export {
  joinSgcmMedia,
  joinSgcmMobileSite,
  joinSgcmMsSite,
  joinSgcmSite,
} from './util';
